import { combineReducers } from 'redux';

import userConstants from './user/constants';
import user from './user/reducer';
import variables from './variables/reducer';
import socket from './socket/reducer';
import vehicles from './vehicles/reducer';
import businessType from './businessType/reducer';
import device from './device/reducer';
import firmwares from './firmware/reducer';
import clients from './client/reducer';
import portals from './portal/reducer';
import inverters from './inverters/reducer';

import geofences from './geofences/reducer';
import alarms from './alarms/reducer';
import modbusMaps from './modbusMaps/reducer';
import telemetry from './telemetry/reducer';
import modelInverters from './modelInverters/reducer';
import accounts from './accounts/reducer';

const reducers = combineReducers({
  user,
  variables,
  accounts,
  alarms,
  modbusMaps,
  telemetry,
  businessType,
  device,
  firmwares,
  clients,
  portals,
  inverters,
  modelInverters,
  vehicles,
  geofences,
  socket,
});

const rootReducer = (state, action) => {

  const { type } = action;

  if (type === userConstants.USER_LOGOUT) {

    // eslint-disable-next-line no-param-reassign
    state = undefined;

  }

  return reducers(state, action);

};

export default rootReducer;
